export default "__VITE_PUBLIC_ASSET__bfbdab3a__"